
  import { KanziEnvironmentModel, CUSTOMERTYPES } from '@kanzi-apes/kanzi-models';
  export const environment: KanziEnvironmentModel = {
    production: false,
    kongTenantApi: '',
    kongApi: 'https://api-mhz-staging.technoapes.io/',
    wmsKongApi: '',
    helpdeskUrl: '',
    kongTrackingFile: '',
    apesPdfCreatorApi: 'https://apes-pdf-creator.technoapes.io/pdf-creator',
    templatePdf: '',
    qsApiUrl: '',
    qsApiUrlCommon: 'https://apes-qs-embed-api.technoapes.io/',
    socketIOServer: '',
    bucket_image_storage: '',
    isQuantity: false,
    tenantId: '03e4311b',
    filterByLocation: true,
    formats: {
      date: 'MM/DD/YYYY',
    },
    pdfTemplatePath: '',
    apiModules: {
      auth: 'auth/',
      authToken: 'token/login/',
      config: 'core_config/',
      inventory: 'inventory/',
      operations: 'operations/',
      rfid: 'rfid/',
      audits: 'inventory/audits/',
      logistics: 'logistics/',
      customers: 'customers/',
      integrations: 'integrations/',
      maintenance: 'maintenance/',
      stock: '',
      invoicing: 'invoicing/',
    },
    configUI: { mainMenuStyle: 'static', scale: 12 },
    assets: {
      logo: 'apes_logo.png',
      background: '',
      root:  'assets/',
      rootClient: '',
      paths: {
        css: 'css/',
        logos: 'images/logos/',
        backgrounds: 'images/backgrounds/',
        js: 'js/',
      },
    },
    modules: {
      customerType: 'ASSETS',
      automaticPrinting: true,
      dashboards: false,
      isEnableButtonExternalId: true,
      editContacts: true,
      discountsContacts: true,
      disabledCreateContacts: false,
      isFilterWerehouse: false,      
      contacts: true,
      contactsParams: true,
      products: {
        parent: true,
        products: false,
        assets: true,
        spareParts: false,
        variableInputs: false,
        maintenanceTrace: false,
        filterTypeSku: true,
        setProperties: true,
        isDisabledCreateProduct: false,
        deleteProduct: false,
        editProducts: true,
        propsRequired:false,
        aditionalParamsInactiveTags: false,
        inactiveTagsAccions: false,
        loadProductGroups: true,
        loadMasterFile: true,
      },
      inventories: {
        parent: true,
        products: false,
        assets: false,        
        booking: false,
        bookingCreate: false,
        bookingList: false,
        hideColumnsSummary: false,
      },
      moves: {
        parent: true,
        dashboards: false,
        moves: true,
        sales: false,
        price: false,
      },
      production: {
        parent: true,
        productionOrder: false,
        productionLocationType: 'WAREHOUSE',
        purchaseOrder: false,
        purchaseLocationType: 'WAREHOUSE',
        printOrder: false,
        filterOrder: false,
        external_id: false,
        productionOrderIdHide: false,
        loadMasterFile: false,
        by_ean: false,
      },
      purchaseOrders:{
        parent: true,
        loadMasterFile: false,
      },
      printOrders:{
        generatePrintFile: false,
      },
      operations: {
        parent: false,
        storeOrder: false,
        distributionOrder: false,
        workOrder: { parent: true, reasignCreateNewOrder: false },
        packings: false,
        dispatchPacks: false,
        budgets: false,
        booking: false,
        woAssignsLeader:true,
        serviceDiscountRates: false
      },
      storeOrders: {
        parent: true,
        loadMasterFile: false,
      },
      audits: {
        parent: false,
        calendar: false,
        products: false,
        assets: false,
        typeAuditProps: 'DEFAULT',
      },
      logisticPacking: {
        parent: false,
        list: false,
        listStates: false,
        create: false,
      },
      maintenance: {
        budgets: 'REQUIRED',
        urlTemplatePdfOT: 'template-ot-dev.docx',
        parent: false,
        scheduler: false,
        orders: false,
        otUndiagnosed: {
          visible: false,
          hasDescription: true,
          isMaintenanceEndpoint: true,
          urlTemplatePDFDiagnosed: 'template-diagnosed.docx',
        },
        // workOrders: { budget: true },
      },
      alerts: false,
    },
  }